import { Injectable } from '@angular/core';
import { RouterModule, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class LoginAuthGuard  {
  constructor(private router: Router) {

  }
  canActivate() {
    if (window.localStorage.getItem('authToken')) {
      this.router.navigate(['/home']);
      return false;
    } else {

      return true;
    }


  }


}